import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as models from '../../models'

export const DOC = gql`
  query QueryUnitsData($tenantId: ID!, $zoneId: ID!, $query: AWSJSON!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        data(query: $query)
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.QueryUnitsDataQuery,
    readonly models.Unit[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'data',
        graphql.transformers.OUT.pipe(
          graphql.transformers.OUT.json(),
          // REVIEW: how to leverage transformers to achieve static type checking?
          graphql.transformers.OUT.custom(originalRecords =>
            TypeAsserter.validateButJustWarn(
              originalRecords,
              // adding custom type asserter to ensure the type is an array of Record
              TypeAsserter.Factory.from(
                TypeChecker.Factory.list(models.Unit.isUnit),
                // this will throw a custom error if the type is not correct
                {
                  customError: (tg, value) =>
                    new TypeAsserter.AssertionError({
                      typeDescription: 'display.summit.allocations.Unit[]',
                      value,
                    }),
                },
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.QueryUnitsDataQuery,
  readonly models.Unit[],
  graphql.schema.QueryUnitsDataQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
